// Locked source of truth: 01_STORIES_01_THE_FLYBY_LOCKED.pdf
// Wording, sequence and Oneworld's proportionate role preserved verbatim.

export const STORIES = [
  {
    num: "01",
    slug: "the-flyby",
    title: "The FlyBy",
    location: "Agra",
    date: "October 2022",
    locationDate: "Agra · October 2022",
    hero: "/stories/flyby-hero.webp",
    detail: "/stories/flyby-detail.webp",

    problem: {
      dateLabel: "10 October 2022",
      headline: "The day before the FlyBy, the smoke was still in Delhi.",
      paragraphs: [
        "Red Bull was preparing for a wingsuit flight over the Taj Mahal with the Soul Flyers, trailing green and orange smoke across the Agra sky.",
        "The smoke needed for the display had to reach Agra.",
        "At 10am on 10 October, it was still in transit in Delhi.",
        "The flight was the following day.",
      ],
      quote: "It required a miracle.",
      quoteAttribution: "Chris Croning · Red Bull India",
    },

    connection: {
      headline: "A connection that could help.",
      paragraphs: [
        "Oneworld had worked with Red Bull for years.",
        "We had also worked with DHL.",
        "When the problem came up, we realised there might be a useful connection between the two and made the introduction.",
        "A few calls followed. DHL stepped in, and the shipment moved to Agra.",
      ],
      closing: [
        "It was one small connection in a much larger effort.",
        "On this occasion, the stars aligned.",
      ],
    },

    resolution: {
      lines: ["The shipment arrived.", "The FlyBy happened."],
      dateLabel: "11–12 October 2022",
    },
  },
];

export const getStory = (slug) => STORIES.find((s) => s.slug === slug);
